import { render, staticRenderFns } from "./AddStudent.vue?vue&type=template&id=6aeeaf2e&"
import script from "./AddStudent.vue?vue&type=script&lang=js&"
export * from "./AddStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports